import { js_utils } from "../frfr-js-utils";


/*
TODO

schema koje vrste polja su number string i array
*/


//
export const _zzsurvey_utils_questions_lib_obj = {
  "TEXT": {
    published: true,
    answer_type_is_string: true,
    // has_extra_ansver: false,
  },
  "YES_NO": {
    published: true,
    answer_type_is_bool: true,
    has_extra_ansver: true,
  },
  "ABC": {
    published: true,
    answer_type_is_string: true,
    has_extra_ansver: true,
  },
  "STARS_5": {
    published: true,
    answer_type_is_number: true,
    has_extra_ansver: true,
  },
  "SCALE_5": {
    published: true,
    answer_type_is_number: true,
    has_extra_ansver: true,
  },
  "CHECKLIST": {
    published: true, // TODO
    answer_type_is_arr: true,
    has_extra_ansver: true,
  },
};
/*
const question_type_keys = ["TEXT", "YES_NO", "ABC", "STARS_5", "SCALE_5", "CHECKLIST"];
const question_type_with_extra_question_keys = ["YES_NO", "ABC", "STARS_5", "SCALE_5", "CHECKLIST"];
const answer_type_bool_keys = ["YES_NO"];
const answer_type_string_keys = ["TEXT", "ABC"];
const answer_type_number_keys = ["STARS_5", "SCALE_5"];
const answer_type_arr_keys = ["CHECKLIST"];
const temp_question_type_keys = ["TEXT", "YES_NO", "STARS_5"];
*/


//
let tempkeyCounter_state = 100;
export const _zzsurvey_utils_generateFreshTempkey = (n) => {
  tempkeyCounter_state++;
  if (n > tempkeyCounter_state || n === tempkeyCounter_state) {
    tempkeyCounter_state = n + 1;
  }
  return tempkeyCounter_state;
};


//
export const _zzsurvey_utils_initial_singleQuestionState_make = (question_type, oldState, is_init) => {
  const singleQuestionState = {};
  if (is_init === true) {
    singleQuestionState.tempkey = _zzsurvey_utils_generateFreshTempkey();
    singleQuestionState.question_type = ''; // TODO
    singleQuestionState.title = '';
  }
  if (js_utils.is_object(oldState) && oldState.tempkey) {
    singleQuestionState.tempkey = oldState.tempkey;
  }
  //
  if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.published === true) {
    singleQuestionState.question_type = question_type;
    singleQuestionState.title = '';
    singleQuestionState.required = false; // true znači da customer mora obavezno da odgovori na ovo pitanje inače forma neće biti validna za submit.
    if (js_utils.is_object(oldState)) {
      if (typeof oldState.title === 'string') {
        singleQuestionState.title = oldState.title;
      }
      if (typeof oldState.required === 'boolean') {
        singleQuestionState.required = oldState.required;
      }
    }
    // singleQuestionState.answer = null; // TODO
    if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.has_extra_ansver === true) { // TODO
      // Propertiji za extra answer mogu da se pojavljuju kod svih tipova pitanja izuzev 'TEXT':
      singleQuestionState.extra_answer_enabled = false; // znači da polje za extra answer može da se pojavi. Ako je false neće se pojaviti nikako.
      singleQuestionState.extra_question_title = '';
      singleQuestionState.extra_answer_required = false; // znači da je extra answer obavezno mora da se popuni ukoliko se polje pojavi
      singleQuestionState.extra_answer_condition = null; // znači da se extra answer pojavljuje kada se value answera podudara sa condition. Ako ovaj properti postoji ali je null znači da se polje svakako prikazuje nije uslovljeno ničim. null bukvalno znači nema uslova.
      // NAPOMENA: ukoliko je question_type 'CHECKLIST' a condition je "" (prazan string) to znači da se polje pojavljuje ako nije checkirana ni jedna opcija. Do daljnjeg nećemo ništa više komplikovati sa checklistom.
      singleQuestionState._extra_answer_condition_enabled = false; // TODO
      if (js_utils.is_object(oldState)) {
        if (oldState.extra_answer_enabled === 'boolean') {
          singleQuestionState.extra_answer_enabled = oldState.extra_answer_enabled;
        }
        if (oldState.extra_question_title === 'string') {
          singleQuestionState.extra_question_title = oldState.extra_question_title;
        }
        if (oldState.extra_answer_required === 'boolean') {
          singleQuestionState.extra_answer_required = oldState.extra_answer_required;
        }
        if ('extra_answer_condition' in oldState) {
          singleQuestionState.extra_answer_condition = oldState.extra_answer_condition;
        }
        if (oldState._extra_answer_condition_enabled === 'boolean') {
          singleQuestionState._extra_answer_condition_enabled = oldState._extra_answer_condition_enabled;
        }
      }
    }
    //
    if (question_type === "TEXT") { // nothing to do
    } else if (question_type === "YES_NO") { // nothing to do
    } else if (question_type === "ABC") {
      singleQuestionState.question_option_titles = { // DEFAULTS
        "A": 'Alfa', // u tabeli questions ovo polja nazvati opt_a
        "B": 'Bravo', // u tabeli questions ovo polja nazvati opt_b
        "C": 'Charlie', // u tabeli questions ovo polja nazvati opt_c
        "D": null, // itd...
        "E": null, // znači da u ovom slučaju opcija E ne postoji
        "F": null, // znači da u ovom slučaju opcija ne postoji
        "G": null, // znači da u ovom slučaju opcija ne postoji
        "H": null, // znači da u ovom slučaju opcija ne postoji
        "I": null, // znači da u ovom slučaju opcija ne postoji
        "J": null, // znači da u ovom slučaju opcija ne postoji
      };
      if (js_utils.is_object(oldState)) {
        if (Array.isArray(oldState.question_option_titles)) {
          singleQuestionState.question_option_titles = oldState.question_option_titles;
        }
      }
    } else if (question_type === "STARS_5") { // nothing to do
    } else if (question_type === "SCALE_5") {
      singleQuestionState.question_option_titles = { // DEFAULTS
        "100": "Almost certain", // u tabeli questions ovo polja nazvati opt_scale100
        "75": "Highly likely", // u tabeli questions ovo polja nazvati opt_scale75
        "50": "Likely/probable", // u tabeli questions ovo polja nazvati opt_scale50
        "25": "Unlikely", // u tabeli questions ovo polja nazvati opt_scale25
        "0": "Almost certainly not", // u tabeli questions ovo polja nazvati opt_scale0
      };
      if (js_utils.is_object(oldState)) {
        if (Array.isArray(oldState.question_option_titles)) {
          singleQuestionState.question_option_titles = oldState.question_option_titles;
        }
      }
    } else if (question_type === "CHECKLIST") { // TODO
      singleQuestionState.question_checklist = ['Prvi check'];
      if (js_utils.is_object(oldState)) {
        if (Array.isArray(oldState.question_checklist)) {
          singleQuestionState.question_checklist = oldState.question_checklist;
        }
      }
    } else {
    }
  } else {
    singleQuestionState.question_type = null;
  }
  //
  return singleQuestionState;
};


//
export const _zzsurvey_utils_singleQuestionState_to_extra_answer_props = (q) => {
  console.log('q', q);
  let _extra_answer_props = {};
  const question_type = q.question_type;
  if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.has_extra_ansver === true) {
    if (q.extra_answer_enabled === true) {
      _extra_answer_props.extra_answer_enabled = true;
      _extra_answer_props.extra_question_title = q.extra_question_title;
      if (typeof q.extra_answer_required === 'boolean') {
        _extra_answer_props.extra_answer_required = q.extra_answer_required;
      } else {
        _extra_answer_props.extra_answer_required = false;
      }
      // TODO 
      _extra_answer_props.extra_answer_condition = null; // null - NO CONDITION
    } else {
      _extra_answer_props.extra_answer_enabled = false;
    }
  }
  console.log('_extra_answer_props', _extra_answer_props);
  // else
  return _extra_answer_props;
};


//
export const _zzsurvey_utils_quizEditorState_initial_blank_make = () => {
  const _header = {
    /*
    title: 'Quiz title',
    survey_text: null,
    survey_img_src: null,
    // date_due: '2030-12-31',
    service_type: null,
    */
    internal_name: '',
    title: 'Quiz title',
    survey_text: null,
    survey_img_src: null,
    // date_due: '2030-12-31',
    // service_type: null,
    service_type: 'Prodaja', // service_type must be either Prodaja or Servis.
    _by_email_or_direct: '', // NOVO 2025-07-12
    first_email_title: '',
    first_email_content: '',
    second_email_title: '',
    second_email_content: '',
    is_review: false,
    review_text: 'Please review us on Google',
    review_link: null,
    //
    // survey_template_id: backendQuizBlueprint.survey_template_id, // TODO
    is_anonymous: false, // NEW
    /*
    "client_id": 1,
    "title": "Please fill our SAMSUNG survey.",
    "text": "Your opinion is important to us!",
    "img_src": {{image_base64}},
    "service_type": "Servis",
    "first_email_title": "Please complete our survey.",
    "first_email_content": "Your opinion is important to us. Please take a moment to complete the following survey:",
    "second_email_title": "Reminder: Please complete our survey.",
    "second_email_content": "This is a friendly reminder to complete the survey we sent you:",
    */
  };
  const initialQuizEditorState = {
    ..._header,
    questions: [], // questions state
  };
  //
  return initialQuizEditorState;
};


//
export const _zzsurvey_utils_dummyResPayload_v1_to_quizEditorState = (payload) => {
  const _header = {
    internal_name: payload.internal_name,
    title: payload.title,
    survey_text: payload.survey_text,
    survey_img_src: payload.survey_img_src,
    // date_due: '2030-12-31',
    service_type: payload.service_type,
    first_email_title: payload.first_email_title,
    first_email_content: payload.first_email_content,
    second_email_title: payload.second_email_title,
    second_email_content: payload.second_email_content,
    is_review: payload.is_review,
    review_text: payload.review_text,
    review_link: payload.review_link,
  };
  const initialQuizEditorState = {
    ..._header,
    questions: [], // questions state
  };
  initialQuizEditorState.questions = payload.questions.map((item) => {
    const new_item = {
      ..._zzsurvey_utils_initial_singleQuestionState_make(item.question_type, item),
      // ...item,
      tempkey: _zzsurvey_utils_generateFreshTempkey(),
    };
    delete new_item.question_id;
    delete new_item.answer_id;
    return new_item;
  });
  //
  return initialQuizEditorState;
};


//
export const _zzsurvey_utils_backendQuizBlueprint_to_quizEditorState = (backendQuizBlueprint) => {
  console.log('_zzsurvey_utils_backendQuizBlueprint_to_quizEditorState');
  console.log('backendQuizBlueprint', backendQuizBlueprint);
  const initialQuizEditorState = _zzsurvey_utils_quizEditorState_initial_blank_make();
  // let counter = 0;
  const prepared = {
    ...initialQuizEditorState,
    internal_name: '',
    title: 'Clone of ' + backendQuizBlueprint.title,
    survey_text: backendQuizBlueprint.text,
    // survey_img_src: backendQuizBlueprint.img_url,
    survey_img_src: null,
    // date_due: '2030-12-31',
    service_type: backendQuizBlueprint.service_type,
    _by_email_or_direct: '', // NOVO 2025-07-12
    first_email_title: backendQuizBlueprint.first_email_title,
    first_email_content: backendQuizBlueprint.first_email_content,
    second_email_title: backendQuizBlueprint.second_email_title,
    second_email_content: backendQuizBlueprint.second_email_content,
    is_review: false,
    review_text: null,
    review_link: null,
    //
    // survey_template_id: backendQuizBlueprint.survey_template_id, // TODO
    // is_anonymous: backendQuizBlueprint.is_anonymous, // NEW
    // questions: [],
  };
  if (backendQuizBlueprint.is_review === true) {
    prepared.is_review = backendQuizBlueprint.is_review;
    prepared.review_text = backendQuizBlueprint.review_text;
    prepared.review_link = backendQuizBlueprint.review_link;
  }
  backendQuizBlueprint.questions.forEach((item, index) => {
    let question_type = item.question_type.toUpperCase(); // TODO
    if (question_type === "YESNO") {
      question_type = "YES_NO";
    }
    if (question_type === "STARS") {
      question_type = "STARS_5";
    }
    if (question_type === "SCALE") {
      question_type = "SCALE_5";
    }
    //
    // ----- convert queastions
    const frontizedQuestion = {};
    frontizedQuestion.title = item.title;
    frontizedQuestion.required = false;
    if (typeof item.required === 'boolean') {
      frontizedQuestion.required = item.required;
    }
    if (question_type === "TEXT") {
      if (item.answer) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "YES_NO") {
      /*
      answer: false
      answer_id: 5
      ...
      question_id: 10
      question_type: "yesno"
      title: "Ovo je jyes no pitanje"
      */
      if (typeof item.answer === 'boolean') { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "STARS_5") {
      if (item.answer > 0) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "SCALE_5") {
      // TODO
      /*
      {
          "question_id": 4,
          "q": {
              "question_id": 4,
              "question_type": "SCALE_5",
              "title": "Neki scale",
              "a": null,
              "b": null,
              "c": null,
              "d": null,
              "e": null,
              "f": null,
              "g": null,
              "h": null,
              "i": null,
              "j": null,
              "opt_scale100": null,
              "opt_scale75": null,
              "opt_scale50": null,
              "opt_scale25": null,
              "opt_scale0": null,
              "checklist": null,
              "extra_answer_enabled": false,
              "extra_answer_required": null,
              "extra_question_title": null,
              "extra_answer_condition": null,
              "answer": null
          },
          "answer_main": null,
          "answer_extra": null
      }
      */
      /*
      singleQuestionState.question_option_titles = { // DEFAULTS
        "100": "Almost certain", // u tabeli questions ovo polja nazvati opt_scale100
        "75": "Highly likely", // u tabeli questions ovo polja nazvati opt_scale75
        "50": "Likely/probable", // u tabeli questions ovo polja nazvati opt_scale50
        "25": "Unlikely", // u tabeli questions ovo polja nazvati opt_scale25
        "0": "Almost certainly not", // u tabeli questions ovo polja nazvati opt_scale0
      };
      */
      if (item.answer) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
      frontizedQuestion.question_option_titles = {};
      if (item.opt_scale100) { frontizedQuestion.question_option_titles["100"] = item.opt_scale100; } else { frontizedQuestion.question_option_titles["100"] = null; }
      if (item.opt_scale75) { frontizedQuestion.question_option_titles["75"] = item.opt_scale75; } else { frontizedQuestion.question_option_titles["75"] = null; }
      if (item.opt_scale50) { frontizedQuestion.question_option_titles["50"] = item.opt_scale50; } else { frontizedQuestion.question_option_titles["50"] = null; }
      if (item.opt_scale25) { frontizedQuestion.question_option_titles["25"] = item.opt_scale25; } else { frontizedQuestion.question_option_titles["25"] = null; }
      if (item.opt_scale0) { frontizedQuestion.question_option_titles["0"] = item.opt_scale0; } else { frontizedQuestion.question_option_titles["0"] = null; }
    }
    if (question_type === 'ABC') {
      if (item.answer) { frontizedQuestion.answer = item.answer?.toUpperCase(); } else { frontizedQuestion.answer = null; }
      frontizedQuestion.question_option_titles = {};
      if (item.a) { frontizedQuestion.question_option_titles["A"] = item.a; } else { }
      if (item.b) { frontizedQuestion.question_option_titles["B"] = item.b; } else { }
      if (item.c) { frontizedQuestion.question_option_titles["C"] = item.c; } else { }
      if (item.d) { frontizedQuestion.question_option_titles["D"] = item.d; } else { }
      if (item.e) { frontizedQuestion.question_option_titles["E"] = item.e; } else { }
      if (item.f) { frontizedQuestion.question_option_titles["F"] = item.f; } else { }
      if (item.g) { frontizedQuestion.question_option_titles["G"] = item.g; } else { }
      if (item.h) { frontizedQuestion.question_option_titles["H"] = item.h; } else { }
      if (item.i) { frontizedQuestion.question_option_titles["I"] = item.i; } else { }
      if (item.j) { frontizedQuestion.question_option_titles["J"] = item.j; } else { }
      /*
        singleQuestionState.question_option_titles = { // DEFAULTS
          "A": 'Alfa', // u tabeli questions ovo polja nazvati opt_a
          "B": 'Bravo', // u tabeli questions ovo polja nazvati opt_b
          "C": 'Charlie', // u tabeli questions ovo polja nazvati opt_c
          "D": null, // itd...
          "E": null, // znači da u ovom slučaju opcija E ne postoji
          "F": null, // znači da u ovom slučaju opcija ne postoji
          "G": null, // znači da u ovom slučaju opcija ne postoji
          "H": null, // znači da u ovom slučaju opcija ne postoji
          "I": null, // znači da u ovom slučaju opcija ne postoji
          "J": null, // znači da u ovom slučaju opcija ne postoji
        };
      */
    }
    if (question_type === 'CHECKLIST') { // TODO
      frontizedQuestion.question_checklist = [];
      frontizedQuestion.answer = [];
      if (Array.isArray(item.answer)) {
        /*
        "answer": [
          "false",
          "true"
        ],
        */
        item.answer.forEach((a, index) => {
          if (a === true || a === "true") {
            frontizedQuestion.answer.push(true);
          } else {
            frontizedQuestion.answer.push(false);
          }
        });
      } else {
        item.checklist.forEach((title, index) => {
          frontizedQuestion.answer.push(false);
        });
      }
      if (Array.isArray(item.checklist)) {
        /*
        "checklist": [
          "Prvi check",
          "Drugi check"
        ],
        */
        /*
        backendizedQProps.checklist = [];
        q.question_checklist.forEach((c_item) => {
          backendizedQProps.checklist.push(c_item);
        });
        */
        item.checklist.forEach((title, index) => {
          frontizedQuestion.question_checklist.push(title);
        });
      }
    }
    //
    if (item.answer && typeof item.extra_answer === 'string') {
      frontizedQuestion.extra_answer = item.extra_answer; // estra_text
    } else {
      frontizedQuestion.extra_answer = null; //
    }
    //
    // ---TODO
    frontizedQuestion.extra_question_title = item.extra_question_title;
    frontizedQuestion.extra_answer_enabled = item.extra_answer_enabled;
    frontizedQuestion.extra_answer_required = false;
    if (typeof item.extra_answer_required === 'boolean') {
      frontizedQuestion.extra_answer_required = item.extra_answer_required;
    }
    frontizedQuestion.extra_answer_condition = item.extra_answer_condition;
    //
    //
    let answer = null; // TODO
    //
    const _prepared_question = {
      // ...item,
      ...frontizedQuestion,
      backend_question: { ...item },
      question_id: item.question_id, // TODO
      tempkey: _zzsurvey_utils_generateFreshTempkey(), // TODO
      question_type: question_type, // TODO
      // answer: answer,
    };
    delete _prepared_question.question_id;
    delete _prepared_question.answer_id;
    _prepared_question.answer = null;
    _prepared_question.extra_answer = null;
    prepared.questions.push(_prepared_question);
    // counter++;
  });
  //
  console.log('prepared', prepared);
  return prepared;
};


//
export const _zzsurvey_utils_quizEditorState_to_quizBlueprint_preview = (editorQuizHeader, editorQuizQuestions, mode) => {
  console.log('_zzsurvey_utils_quizEditorState_to_quizBlueprint_preview - mode', mode);
  console.log('editorQuizQuestions', editorQuizQuestions);
  // let counter = 0;
  const prepared = {
    survey_img_src: editorQuizHeader.survey_img_src,
    internal_name: editorQuizHeader.internal_name,
    title: editorQuizHeader.title,
    survey_text: editorQuizHeader.survey_text,
    // date_due: '2030-12-31',
    // service_type: editorQuizHeader.service_type,
    first_email_title: editorQuizHeader.first_email_title,
    first_email_content: editorQuizHeader.first_email_content,
    second_email_title: editorQuizHeader.second_email_title,
    second_email_content: editorQuizHeader.second_email_content,
    is_review: editorQuizHeader.is_review,
    review_text: editorQuizHeader.review_text,
    review_link: editorQuizHeader.review_link,
    //
    // survey_template_id: backendQuizBlueprint.survey_template_id, // TODO
    // is_anonymous: initialQuizEditorState.is_anonymous, // NEW
    questions: [],
  };
  editorQuizQuestions.forEach((item, index) => {
    let answer = null;
    if (item.question_type === 'CHECKLIST') {
      // if (Array.isArray(item.answer)) {
      //  answer = item.answer;
      // } else {
      answer = [];
      item.question_checklist.forEach((title, index) => {
        answer.push(false);
      });
      // }
    }
    let _question_id = item.question_id;
    if (mode === 'DEMO') {
      _question_id = item.question_id;
    } else {
      _question_id = item.tempkey;
    }
    prepared.questions.push({
      ...item,
      // question_id: item.tempkey, // TODO
      // question_id: item.question_id, // TODO
      question_id: _question_id, // TODO
      answer: answer,
    });
    // counter++;
  });
  //
  return prepared;
};


//
export const _zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint = (backendQuizBlueprint) => {
  console.log('_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint');
  console.log('backendQuizBlueprint', backendQuizBlueprint);
  // let counter = 0;
  const prepared = {
    internal_name: backendQuizBlueprint.internal_name,
    title: backendQuizBlueprint.title,
    survey_text: backendQuizBlueprint.text,
    survey_img_src: backendQuizBlueprint.img_url,
    // date_due: '2030-12-31',
    service_type: backendQuizBlueprint.service_type,
    _by_email_or_direct: '', // NOVO 2025-07-12
    first_email_title: backendQuizBlueprint.first_email_title,
    first_email_content: backendQuizBlueprint.first_email_content,
    second_email_title: backendQuizBlueprint.second_email_title,
    second_email_content: backendQuizBlueprint.second_email_content,
    is_review: false,
    review_text: null,
    review_link: null,
    //
    survey_template_id: backendQuizBlueprint.survey_template_id, // TODO
    is_anonymous: backendQuizBlueprint.is_anonymous, // NEW
    questions: [],
  };
  if (backendQuizBlueprint.is_review === true) {
    prepared.is_review = backendQuizBlueprint.is_review;
    prepared.review_text = backendQuizBlueprint.review_text;
    prepared.review_link = backendQuizBlueprint.review_link;
  }
  backendQuizBlueprint.questions.forEach((item, index) => {
    let question_type = item.question_type.toUpperCase(); // TODO
    if (question_type === "YESNO") {
      question_type = "YES_NO";
    }
    if (question_type === "STARS") {
      question_type = "STARS_5";
    }
    if (question_type === "SCALE") {
      question_type = "SCALE_5";
    }
    //
    // ----- convert queastions
    const frontizedQuestion = {};
    frontizedQuestion.title = item.title;
    frontizedQuestion.required = false;
    if (typeof item.required === 'boolean') {
      frontizedQuestion.required = item.required;
    }
    if (question_type === "TEXT") {
      if (item.answer) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "YES_NO") {
      /*
      answer: false
      answer_id: 5
      ...
      question_id: 10
      question_type: "yesno"
      title: "Ovo je jyes no pitanje"
      */
      if (typeof item.answer === 'boolean') { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "STARS_5") {
      if (item.answer > 0) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
    }
    if (question_type === "SCALE_5") {
      // TODO
      /*
      {
          "question_id": 4,
          "q": {
              "question_id": 4,
              "question_type": "SCALE_5",
              "title": "Neki scale",
              "a": null,
              "b": null,
              "c": null,
              "d": null,
              "e": null,
              "f": null,
              "g": null,
              "h": null,
              "i": null,
              "j": null,
              "opt_scale100": null,
              "opt_scale75": null,
              "opt_scale50": null,
              "opt_scale25": null,
              "opt_scale0": null,
              "checklist": null,
              "extra_answer_enabled": false,
              "extra_answer_required": null,
              "extra_question_title": null,
              "extra_answer_condition": null,
              "answer": null
          },
          "answer_main": null,
          "answer_extra": null
      }
      */
      /*
      singleQuestionState.question_option_titles = { // DEFAULTS
        "100": "Almost certain", // u tabeli questions ovo polja nazvati opt_scale100
        "75": "Highly likely", // u tabeli questions ovo polja nazvati opt_scale75
        "50": "Likely/probable", // u tabeli questions ovo polja nazvati opt_scale50
        "25": "Unlikely", // u tabeli questions ovo polja nazvati opt_scale25
        "0": "Almost certainly not", // u tabeli questions ovo polja nazvati opt_scale0
      };
      */
      if (item.answer) { frontizedQuestion.answer = item.answer; } else { frontizedQuestion.answer = null; }
      frontizedQuestion.question_option_titles = {};
      if (item.opt_scale100) { frontizedQuestion.question_option_titles["100"] = item.opt_scale100; } else { frontizedQuestion.question_option_titles["100"] = null; }
      if (item.opt_scale75) { frontizedQuestion.question_option_titles["75"] = item.opt_scale75; } else { frontizedQuestion.question_option_titles["75"] = null; }
      if (item.opt_scale50) { frontizedQuestion.question_option_titles["50"] = item.opt_scale50; } else { frontizedQuestion.question_option_titles["50"] = null; }
      if (item.opt_scale25) { frontizedQuestion.question_option_titles["25"] = item.opt_scale25; } else { frontizedQuestion.question_option_titles["25"] = null; }
      if (item.opt_scale0) { frontizedQuestion.question_option_titles["0"] = item.opt_scale0; } else { frontizedQuestion.question_option_titles["0"] = null; }
    }
    if (question_type === 'ABC') {
      if (item.answer) { frontizedQuestion.answer = item.answer?.toUpperCase(); } else { frontizedQuestion.answer = null; }
      frontizedQuestion.question_option_titles = {};
      if (item.a) { frontizedQuestion.question_option_titles["A"] = item.a; } else { }
      if (item.b) { frontizedQuestion.question_option_titles["B"] = item.b; } else { }
      if (item.c) { frontizedQuestion.question_option_titles["C"] = item.c; } else { }
      if (item.d) { frontizedQuestion.question_option_titles["D"] = item.d; } else { }
      if (item.e) { frontizedQuestion.question_option_titles["E"] = item.e; } else { }
      if (item.f) { frontizedQuestion.question_option_titles["F"] = item.f; } else { }
      if (item.g) { frontizedQuestion.question_option_titles["G"] = item.g; } else { }
      if (item.h) { frontizedQuestion.question_option_titles["H"] = item.h; } else { }
      if (item.i) { frontizedQuestion.question_option_titles["I"] = item.i; } else { }
      if (item.j) { frontizedQuestion.question_option_titles["J"] = item.j; } else { }
      /*
        singleQuestionState.question_option_titles = { // DEFAULTS
          "A": 'Alfa', // u tabeli questions ovo polja nazvati opt_a
          "B": 'Bravo', // u tabeli questions ovo polja nazvati opt_b
          "C": 'Charlie', // u tabeli questions ovo polja nazvati opt_c
          "D": null, // itd...
          "E": null, // znači da u ovom slučaju opcija E ne postoji
          "F": null, // znači da u ovom slučaju opcija ne postoji
          "G": null, // znači da u ovom slučaju opcija ne postoji
          "H": null, // znači da u ovom slučaju opcija ne postoji
          "I": null, // znači da u ovom slučaju opcija ne postoji
          "J": null, // znači da u ovom slučaju opcija ne postoji
        };
      */
    }
    if (question_type === 'CHECKLIST') { // TODO
      frontizedQuestion.question_checklist = [];
      frontizedQuestion.answer = [];
      if (Array.isArray(item.answer)) {
        /*
        "answer": [
          "false",
          "true"
        ],
        */
        item.answer.forEach((a, index) => {
          if (a === true || a === "true") {
            frontizedQuestion.answer.push(true);
          } else {
            frontizedQuestion.answer.push(false);
          }
        });
      } else {
        item.checklist.forEach((title, index) => {
          frontizedQuestion.answer.push(false);
        });
      }
      if (Array.isArray(item.checklist)) {
        /*
        "checklist": [
          "Prvi check",
          "Drugi check"
        ],
        */
        /*
        backendizedQProps.checklist = [];
        q.question_checklist.forEach((c_item) => {
          backendizedQProps.checklist.push(c_item);
        });
        */
        item.checklist.forEach((title, index) => {
          frontizedQuestion.question_checklist.push(title);
        });
      }
    }
    //
    if (item.answer && typeof item.extra_answer === 'string') {
      frontizedQuestion.extra_answer = item.extra_answer; // estra_text
    } else {
      frontizedQuestion.extra_answer = null; //
    }
    //
    // ---TODO
    frontizedQuestion.extra_question_title = item.extra_question_title;
    frontizedQuestion.extra_answer_enabled = item.extra_answer_enabled;
    frontizedQuestion.extra_answer_required = false;
    if (typeof item.extra_answer_required === 'boolean') {
      frontizedQuestion.extra_answer_required = item.extra_answer_required;
    }
    frontizedQuestion.extra_answer_condition = item.extra_answer_condition;
    //
    //
    let answer = null; // TODO
    //
    prepared.questions.push({
      // ...item,
      ...frontizedQuestion,
      backend_question: { ...item },
      question_id: item.question_id, // TODO
      question_type: question_type, // TODO
      // answer: answer,
    });
    // counter++;
  });
  //
  console.log('prepared', prepared);
  return prepared;
};


// TODO NOVO
export const _zzsurvey_utils_quizBlueprint_to_initialAnswersState = (quizBlueprint, mode) => {
  console.log('quizBlueprint', quizBlueprint);
  // const initialAnswersState = {};
  const initialAnswersState = [];
  quizBlueprint.questions.forEach((item) => {
    const key = item.question_id;
    const question_type = item.question_type;
    // initialAnswersState[key] = {
    let answer = null;
    let answer_extra = null;
    /*
    if (item.answer) {
      answer = item.answer;
    }
    */
    if (question_type === 'CHECKLIST') {
      answer = [];
      item.question_checklist.forEach((title, index) => {
        answer.push(false);
      });
    }
    if (mode === 'LIVE_PREVIEW') {
      if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.answer_type_is_string === true && typeof item.answer === 'string') {
        // initialAnswersState[key].answer_main = item.answer;
        answer = item.answer;
      }
      if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.answer_type_is_number === true && js_utils.is_number(item.answer)) {
        // initialAnswersState[key].answer_main = item.answer;
        answer = item.answer;
      }
      if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.answer_type_is_bool === true && (item.answer === true || item.answer === false)) {
        // initialAnswersState[key].answer_main = item.answer;
        answer = item.answer;
      }
      if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.answer_type_is_arr === true && Array.isArray(item.answer)) {
        // initialAnswersState[key].answer_main = item.answer;
        answer = item.answer;
      }
      //
      if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.has_extra_ansver === true && typeof item.extra_answer === 'string') {
        // initialAnswersState[key].answer_extra = item.extra_answer; // estra_text
        answer_extra = item.extra_answer; // estra_text
      }
    }
    initialAnswersState.push({
      question_id: key,
      q: { ...item },
      answer_main: answer,
      answer_extra: answer_extra,
    });
    /*
    if (question_type === "CHECKLIST") {
      // TODO
      // initialAnswersState[key].answer_main = [];
      initialAnswersState[key].answer_main = item.answer;
    }
    */
  });
  console.log('initialAnswersState', initialAnswersState);
  return initialAnswersState;
};


// ---- QUIZ FORM


//
const _def_part_id_readonly = [
  {
    "type": "input_text",
    "params": {
      "readonly": true,
      "label": "tempkey",
      "name": "tempkey",
      "w": 100
    }
  },
];
const _def_part_common = [
  {
    // "type": "input_text",
    "type": "textarea",
    "params": {
      // "readonly": true,
      "label": "title",
      "name": "title",
      "w": 320
    }
  },
  {
    "type": "input_checkbox",
    "params": {
      "label": "required",
      "name": "required",
    }
  },
];
const _def_part_extra_answer_enabled = [
  {
    "type": "input_checkbox",
    "params": {
      "label": "extra_answer_enabled",
      "name": "extra_answer_enabled",
    }
  },
];
const _def_part_extra_question_title = [
  {
    // "type": "input_text",
    "type": "textarea",
    "params": {
      // "readonly": true,
      "label": "extra_question_title",
      "name": "extra_question_title",
      "w": 320
    }
  },
];
const _def_part_extra_answer_required = [
  {
    "type": "input_checkbox",
    "params": {
      "label": "extra_answer_required",
      "name": "extra_answer_required",
    }
  },
  /*
  {
    "type": "input_checkbox",
    "params": {
      "label": "extra_answer_condition",
      "name": "extra_answer_condition", // TODO
    }
  },
  */
];
//
export const _zzsurvey_formDefiinitionSingleQuestion_make = (singleQuestionState) => {
  const state = singleQuestionState;
  const question_type = state.question_type;
  const extra_answer_enabled = state.extra_answer_enabled;
  // const extra_answer_required = state.extra_answer_required;
  const def = [];
  //
  if (question_type === "TEXT") {

  } else if (question_type === "YES_NO") {
  } else if (question_type === "444444444444444444444") {

  } else {

  }

  // def.push(..._def_part_id_readonly);
  def.push(..._def_part_common);
  if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.has_extra_ansver === true) {
    def.push(..._def_part_extra_answer_enabled);
    if (extra_answer_enabled === true) {
      def.push(..._def_part_extra_question_title);
      def.push(..._def_part_extra_answer_required);
    }
  }
  //
  return def;
};

